import { Instagram } from "lucide-react";

// Shared Instagram widget (same embed used on the homepage / View All page).
export default function InstagramWidget() {
  return (
    <div className="rounded-2xl overflow-hidden border border-gray-200 shadow-sm bg-white" style={{ fontFamily: "'Poppins', sans-serif" }}>
      <div className="flex items-center gap-2 px-4 py-3 border-b border-gray-100">
        <div className="w-6 h-6 rounded-full bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600 flex items-center justify-center shrink-0">
          <Instagram className="w-3.5 h-3.5 text-white" />
        </div>
        <span className="text-[13px] font-semibold text-gray-800">@tastebudsbyanubhi</span>
      </div>
      <iframe
        src="https://www.instagram.com/tastebudsbyanubhi/embed"
        width="100%"
        height="340"
        frameBorder="0"
        scrolling="no"
        allowTransparency={true}
        style={{ border: "none", overflow: "hidden", display: "block" }}
        title="TasteBudsByAnubhi Instagram Feed"
      />
      <div className="px-4 py-3 border-t border-gray-100 flex justify-center">
        <a
          href="https://www.instagram.com/tastebudsbyanubhi"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 px-5 py-2.5 rounded-full text-white text-sm font-semibold transition-transform hover:scale-105 active:scale-95"
          style={{ background: "linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)" }}
        >
          <Instagram className="w-4 h-4" />
          Follow on Instagram
        </a>
      </div>
    </div>
  );
}
